import React from 'react';

const SvgCalendar = props => (
  <svg width={13} height={14} {...props}>
    <path
      d="M9 2H4v.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V2H1v11h11v-2h-2v2H9v-2H7v2H6v-2H4v2H3v-2H1v-1h2V8H1V7h2V5H1V4h11V2h-1v.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V2zm2-1h1a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h1V.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V1h5V.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V1zM9 5H7v2h2V5zm1 0v2h2V5h-2zM9 8H7v2h2V8zm1 0v2h2V8h-2zM6 5H4v2h2V5zm0 3H4v2h2V8z"
      fill="#046FE2"
      fillRule="nonzero"
    />
  </svg>
);

export default SvgCalendar;
